import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  Input,
  output,
  signal,
  WritableSignal,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { distinctUntilChanged, Subscription } from 'rxjs';

@Component({
  selector: 'base-control',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
})
export class ControlBase {
  control = input.required<FormControl>();
  label = input<string>('');
  placeholder = input<string>('');
  controlChanges = output<any>();

  baseClasses = 'w-full';
  valueChangesInit = signal<boolean>(false);

  private _value: WritableSignal<any> = signal(null);
  private valueChangesSubscription?: Subscription;

  @Input()
  set value(newValue: any) {
    this._value.set(newValue);
  }

  constructor() {
    effect(() => {
      const currentValue = this._value();
      if (currentValue !== null) {
        this.handleValueChange(currentValue);
      }
    });
  }

  ngOnInit() {
    if (this.valueChangesInit() === false && !this.valueChangesSubscription) {
      this.valueChangesInit.set(true);
      // Subscribe to valueChanges only once and handle cleanup properly
      this.valueChangesSubscription = this.control()
        .valueChanges.pipe(distinctUntilChanged())
        .subscribe((value) => this.controlChanges.emit(value));
    }
  }

  ngOnDestroy() {
    // Unsubscribe from the observable when the component is destroyed
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }

  handleValueChange(newValue: any): void {
    this.control().patchValue(newValue, { emitEvent: false });
  }
}
